import { Checkbox } from '@leadsnavi/ui-kit';
import cn from 'classnames';

interface PrivacyCheckboxProps {
  /** 是否选中 */
  checked: boolean;
  /** 选中状态变化回调 */
  onChange: (checked: boolean) => void;
  /** 点击隐私政策链接 */
  onPrivacyPolicyClick?: () => void;
  /** 自定义类名 */
  className?: string;
}

/**
 * 隐私政策复选框组件
 */
export function PrivacyCheckbox({ checked, onChange, onPrivacyPolicyClick, className }: PrivacyCheckboxProps) {
  return (
    <div className={cn('flex items-center gap-[8px]', className)}>
      <Checkbox
        checked={checked}
        onCheckedChange={onChange}
        className="h-[16px] w-[16px] rounded-[3px] border-[#e5e5e5] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] data-[state=checked]:border-[#171717] data-[state=checked]:bg-[#171717]"
      />
      <span className="text-[14px] font-normal leading-[1.5] tracking-[0.07px] text-[#525252]">
        I agree to the{' '}
        <button type="button" onClick={onPrivacyPolicyClick} className="text-[#10b981] underline hover:text-[#059669]">
          Privacy Policy
        </button>
      </span>
    </div>
  );
}

export default PrivacyCheckbox;
